import UserAvatarPopover from './UserAvatarPopover'

export default UserAvatarPopover
